'use client';

import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, MessageSquare } from 'lucide-react';
import CasinoChat from '@/app/components/Chat/CasinoChat';

interface Props {
    open: boolean;
    onClose: () => void;
}

export default function ChatSidebar({ open, onClose }: Props) {
    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [open]);

    return (
        <AnimatePresence>
            {open && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 z-[55] bg-black/40"
                    />

                    {/* Panel */}
                    <motion.div
                        initial={{ x: '100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '100%' }}
                        transition={{ type: 'spring', damping: 28, stiffness: 220 }}
                        className="fixed top-0 right-0 h-full w-full sm:w-96 z-[60] flex flex-col bg-gray-900 shadow-2xl shadow-black/60"
                    >
                        {/* Header */}
                        <div className="flex items-center gap-3 px-4 py-4 shrink-0">
                            <MessageSquare className="w-5 h-5 text-white" />
                            <span className="font-semibold text-white text-base">Chat</span>
                            <button
                                onClick={onClose}
                                className="ml-auto p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-all duration-200"
                            >
                                <X className="w-4 h-4" />
                            </button>
                        </div>

                        {/* Chat fills the rest */}
                        <CasinoChat
                            hideHeader
                            className="flex flex-col flex-1 min-h-0 bg-gray-900 overflow-hidden"
                        />
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
